import React from "react";

import { css } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useScroll } from "@/hooks/useScroll.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type BackToTopProps = {
  id?: string;
  threshold?: number;
};

export const BackToTop: React.FC<BackToTopProps> = ({ id, threshold = 1000 }) => {
  const styles = useStyles(makeStyles);
  const scroll = useScroll();

  return scroll.current > threshold ? (
    <div id={id} className={styles.backToTop}>
      <Button
        data-action="common.scroll.top"
        variant="contained"
        startIcon={<Icons.chevronUp className={styles.moreContentIcon} />}
        className={styles.moreContentButton}
        onClick={() => window.scroll({ top: 0, behavior: "smooth" })}
      />
    </div>
  ) : null;
};

const makeStyles = (theme: Theme) => ({
  backToTop: css({
    position: "fixed",
    bottom: theme.spacing(12),
    alignSelf: "flex-end",
    justifySelf: "flex-end",
    zIndex: theme.zIndex.fab,
    stroke: theme.palette.grey[900],
  }),
  moreContentButton: css({
    padding: theme.spacing(4, 8),
    color: theme.palette.common.white,
  }),
  moreContentIcon: css({
    width: FontSizes.bodyLarge,
    height: FontSizes.bodyLarge,
  }),
});
